import { css } from '@/styled-system/css';

export const container = css({
  display: 'none',
  md: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '2x',
  },
});

export const toggleGroup = css({
  display: 'flex',
  gap: '1x',
});

const toggleButtonBase = css.raw({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  minHeight: '32px',
  padding: '4px 10px',
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '1',
  cursor: 'pointer',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '4px',
  transition: 'background-color 0.15s, color 0.15s',
});

export const toggleButtonActive = css(toggleButtonBase, {
  bg: 'hpxTeal500',
  color: 'hpxWhite',
  borderColor: 'hpxTeal500',
});

export const toggleButtonInactive = css(toggleButtonBase, {
  bg: 'hpxWhite',
  color: 'hpxBlue600',
  borderColor: 'hpxGrey400',
  _hover: {
    bg: 'hpxGrey100',
  },
});

export const iconStyle = css({
  width: '14px',
  height: '14px',
});

export const feedButton = css({
  color: 'hpxBlue600',
  borderColor: 'hpxGrey400',
});

export const mobileToggleIcon = css({
  width: '16px',
  height: '16px',
  flexShrink: 0,
});
